// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Anastasia Chesnovskaya <anastasia.chesnovskaya@celadon.ae>

import { put, call, takeEvery } from 'redux-saga/effects';

import {
  validatePhoneNumberService,
  validateBankAccountService,
  getFundraisePageDataService,
  RegisterCharityService
} from './service';
import * as fundraiseActions from './actions';
import * as types from './actionTypes';


function* validatePhoneNumberFundraiseSaga(payload) {
  const { data, dataForValidBank, dataForNextRequest } = payload;
  const errorText = 'Invalid contact number.';

  const res = yield call(validatePhoneNumberService, data);

  if (res.ok) {
    if (res.body.result && res.body.carrier.type === 'mobile') {
      yield put(fundraiseActions.validateBankAccount(dataForValidBank, dataForNextRequest));
    } else {
      yield put(fundraiseActions.setError(errorText));
    }
  }
}

function* validateBankAccountSaga(payload) {
  const { sortCode, accountNumber } = payload.data;
  const commonErrorText = 'Invalid Sort Code or Account Number.';
  const errorTextSortCode = 'Sort Code must be numeric and 6 in length.';
  const errorTextAccountNumber = 'Account Number must be numeric and 8 in length.';

  yield put(fundraiseActions.resetError());

  const res = yield call(validateBankAccountService, payload.data);

  if (res.ok && accountNumber.length === 8) {
    if (res.body.bankValidate.isCorrect) {
      yield put(fundraiseActions.registerCharity(payload.dataForNextRequest));
    } else {
      yield put(fundraiseActions.setError(commonErrorText));
    }
  } else {
    const regex = /^[0-9]+$/;
    const errorText = (sortCode.length !== 6 || !regex.test(sortCode)) ? errorTextSortCode : (
      (accountNumber.length !== 8 || !regex.test(accountNumber))
        ? errorTextAccountNumber : commonErrorText
    );

    yield put(fundraiseActions.setError(errorText));
  }
}

function* getFundraisePageSaga() {
  const res = yield call(getFundraisePageDataService);
  if (res.ok) {
    const result = res.body.items[0];
    const { title, text, confirm_text } = result;
    yield put(fundraiseActions.getFundraisePageDataSuccess({
      title,
      text,
      confirm_text,
    }));
  }
}

function* registerCharitySaga(payload) {
  const res = yield call(RegisterCharityService, payload.data);
  yield put(fundraiseActions.setIsButtonPressed(true));
  window.scrollTo(0, 0);
  if (res.ok && res.body) {
    yield put(fundraiseActions.registerCharitySuccess(res.body));
  }
}

const fundraiseSagas = [
  takeEvery(types.VALIDATE_PHONE_NUMBER_FUNDRAISE, validatePhoneNumberFundraiseSaga),
  takeEvery(types.VALIDATE_BANK_ACCOUNT, validateBankAccountSaga),
  takeEvery(types.GET_FUNDRAISE_PAGE_DATA, getFundraisePageSaga),
  takeEvery(types.REGISTER_CHARITY, registerCharitySaga),
];

export default fundraiseSagas;
